import React from 'react';

import StoryTeaser from './Teaser';
import StoryDetail from './Detail';

const NodeStory = (props) => {
  const { viewMode } = props;
  if (viewMode === 'teaser') {
    return <StoryTeaser {...props} />;
  }

  return <StoryDetail {...props} />;
};

export default NodeStory;
